export function ColumnTitle({ title }: { title: string | undefined }) {
  return <div className="text-semibold whitespace-nowrap">{title}</div>;
}
